import SubPageHeading from './SubPageHeading';

export default SubPageHeading;
